import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import { api } from "../../../../api";
import Cookies from "js-cookie";

const Employee = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const toggleModal = () => setModalOpen((prevState) => !prevState);

  const emp_id = Cookies.get("token");

  const [project, setProject] = useState([]);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [selectedProject, setSelectedProject] = useState("");
  const [modalEmployee, setModalEmployee] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const company_id = Cookies.get('company_id');
        const response = await api.get(
          `viewProjectDetails.php?p_m_id=${emp_id}&company_id=${company_id}`
        );
        setProject(response.data);
        const response2 = await api.get(
          `employeesView.php?project_id=${emp_id}&company_id=${company_id}`
        );
        setSelectedEmployees(
          Array.isArray(response2.data) ? response2.data : []
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [emp_id]);

  const handleProjectSelection = async (p_id, p_name) => {
    setSelectedProject(p_name);
    try {
      const company_id = Cookies.get('company_id');
      const response = await api.get(`sitemanagerview.php?p_id=${p_id}&company_id=${company_id}`);
      const data = response.data;
      setSelectedEmployees(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setSelectedEmployees([]);
    }
  };

  const filteredEmployees = selectedEmployees.filter((employee) =>
    employee.emp_name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const getImagePath = (imageName) => {
    const isProduction = window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1';
    const defaultImage = isProduction ? '/images/default-profile.png' : '/dashboard/images/default-profile.png';
    
    if (!imageName) return defaultImage;
    
    try {
      const decodedImageName = decodeURIComponent(imageName);
      return isProduction ? `/images/${decodedImageName}` : `/dashboard/images/${decodedImageName}`;
    } catch (error) {
      console.error('Error loading image:', error);
      return defaultImage;
    }
  };

  return (
    <>
      <div className="header bg-gradient-info py-7 py-lg-8">
        <Container fluid>
          <Row className="mb-5">
            <Col className="order-xl-2 mb-5 mb-xl-0 text-left ">
              <h1>Employee Details</h1>
            </Col>
            <Col className="order-xl-2 mb-5 mb-xl-0 d-flex">
              <Form className="navbar-search  form-inline mr-3 d-none d-md-flex ml-lg-auto">
                <FormGroup className="mb-0">
                  <InputGroup className="input-group-alternative">
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i
                          className="fas fa-search"
                          style={{ color: "black" }}
                        />
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      placeholder="Search Employee Name"
                      type="text"
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </InputGroup>
                </FormGroup>
              </Form>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle caret>
                  {selectedProject || "Select Project"}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem
                    onClick={async () => {
                      setSelectedProject("All Projects");
                      // Fetch all employees for all projects
                      try {
                        const company_id = Cookies.get('company_id');
                        const response2 = await api.get(
                          `employeesView.php?project_id=${emp_id}&company_id=${company_id}`
                        );
                        setSelectedEmployees(
                          Array.isArray(response2.data) ? response2.data : []
                        );
                      } catch (error) {
                        setSelectedEmployees([]);
                      }
                    }}
                  >
                    All Projects
                  </DropdownItem>
                  {Array.isArray(project) ? (
                    project.map((project) => (
                      <DropdownItem
                        key={project.p_id}
                        onClick={() =>
                          handleProjectSelection(project.p_id, project.p_name)
                        }
                      >
                        {project.p_name}
                      </DropdownItem>
                    ))
                  ) : (
                    <DropdownItem>No Projects Found</DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row>
            {filteredEmployees && filteredEmployees.length > 0 ? (
              filteredEmployees.map((employee) => (
                <Col md="4" key={employee.sm_id}>
                  <Card
                    className="p-3 shadow-sm"
                    style={{
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
                      backgroundColor: "#fff",
                      borderWidth: "2px",
                      borderStyle: "solid",
                      borderRadius: "20px",
                      width: "350px",
                      backgroundColor: "#fff",
                      position: "relative",
                    }}
                  >
                    <Row className="align-items-center">
                      {/* Profile Image on the Left */}
                      <Col xs="4" className="text-center">
                        <img
                          alt="..."
                          src={getImagePath(employee.profile_image)}
                          style={{
                            height: "100px",
                            width: "100px",
                            objectFit: "cover",
                            borderRadius: "12px",
                          }}
                          onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
                        />
                      </Col>

                      {/* Employee Details */}
                      <Col xs="8">
                        <div
                          className="fw-bold mb-1"
                          style={{ fontSize: "16px" }}
                        >
                          {employee.emp_name}
                        </div>
                        <div
                          className="text-muted mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          <i className="fas fa-envelope me-2"></i>{" "}
                          <span className="truncate">{employee.email}</span>
                        </div>
                        <div
                          className="text-muted mb-1"
                          style={{ fontSize: "14px" }}
                        >
                          <i className="fas fa-phone me-2"></i>{" "}
                          {employee.phoneno}
                        </div>
                        <div
                          className="text-muted"
                          style={{ fontSize: "14px" }}
                        >
                          <i className="fas fa-birthday-cake me-2"></i>{" "}
                          {employee.dob}
                        </div>
                      </Col>
                    </Row>

                    {/* View More link */}
                    <div className="d-flex justify-content-end mt-2">
                      <a
                        href="#pablo"
                        onClick={(e) => {
                          e.preventDefault();
                          setModalEmployee(employee);
                          toggleModal();
                        }}
                        className="text-primary"
                        style={{ fontSize: "15px" }}
                      >
                        View More
                      </a>
                    </div>
                  </Card>
                </Col>
              ))
            ) : (
              <h4>
                Select project to view employee details (OR) No employees
                found..
              </h4>
            )}

            {modalEmployee && (
              <Modal isOpen={modalOpen} toggle={toggleModal}>
                <ModalHeader toggle={toggleModal}>Employee View</ModalHeader>
                <ModalBody
                  style={{ justifyContent: "center", textAlign: "center" }}
                >
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="rounded-circle"
                      src={getImagePath(modalEmployee.profile_image)}
                      style={{ height: 100, marginBottom: 10 }}
                      onError={e => { e.target.onerror = null; e.target.src = '/images/default-profile.png'; }}
                    />
                  </a>
                  <p>Name: {modalEmployee.emp_name}</p>
                  <p>Date Of Birth: {modalEmployee.dob}</p>
                  <p>Mobile Number: {modalEmployee.phoneno}</p>
                  <p>Email: {modalEmployee.email}</p>
                  <p>Role: {modalEmployee.role}</p>
                  <p>Address: {modalEmployee.address}</p>
                </ModalBody>
              </Modal>
            )}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Employee;